<div class="holder">
  <h3>Registrerad</h3>
</div>
<p>
  {{eventObject}}
</p>
